const OutlineButton = ({
  children,
  theme = "white",
  size = "md",
  target = "_blank",
  link,
  ...props
}) => {
  const buttonSizeClass = getSize(size);
  const buttonThemeClass = getTheme(theme);

  return (
    <a
      href={link}
      target={target}
      rel="noreferrer"
      {...props}
      className={`font-medium cursor-pointer rounded-full border relative group flex items-center justify-center overflow-hidden  transition-all duration-500 ease-in-out  ${buttonSizeClass} ${buttonThemeClass} py-2 px-6 lg:text-lg text-xs lg:py-3 lg:px-8`}
    >
      <div
        className={`absolute z-0 ${
          theme === "black" ? "bg-black" : "bg-white"
        } w-60 h-60 rotate-45 right-[60%] -top-[550%] group-hover:right-0 group-hover:-top-[150%] transition-all duration-500 ease-in-out hidden lg:block`}
      />
      <span className="flex items-center gap-2 relative z-[1]">{children}</span>
    </a>
  );
};

const getTheme = (theme) => {
  if (theme === "black") {
    return "border-black text-black hover:text-white";
  }

  return "border-white text-white hover:text-black";
};
const getSize = (size) => {
  if (size === "sm") {
    return "text-base";
  }

  return "md:text-lg";
};

export default OutlineButton;
